module.exports = __webpack_public_path__ + "img/item5.3c20a7c8.png";